import React from "react";
import { Space } from "@masterteam/mt-design-react";

import useIsAr from "../../../../Hooks/useIsAr";

import { ReactComponent as English } from "../../../../assets/images/login-page-english.svg";
import { ReactComponent as Arabic } from "../../../../assets/images/login-page-arabic.svg";

import "./style.scss";

function NewStrategyPlus() {
  const [isAr] = useIsAr();

  return (
    <Space direction="vertical" className="new-strategy-plus">
      {isAr ? <Arabic /> : <English />}
    </Space>
  );
}

export default NewStrategyPlus;
